/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_DuplicatedInputs */

const en_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume duplicated`)
};

const de_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf dupliziert`)
};

const fr_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV dupliqué`)
};

const es_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum duplicado`)
};

const it_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum duplicato`)
};

const nl_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV gedupliceerd`)
};

const pl_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV zduplikowane`)
};

const fi_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo kopioitu`)
};

const da_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV duplikeret`)
};

const sv_resumes_duplicated = /** @type {(inputs: Resumes_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV duplicerat`)
};

/**
* | output |
* | --- |
* | "Resume duplicated" |
*
* @param {Resumes_DuplicatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_duplicated = /** @type {((inputs?: Resumes_DuplicatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_DuplicatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_duplicated(inputs)
	if (locale === "fr") return fr_resumes_duplicated(inputs)
	if (locale === "es") return es_resumes_duplicated(inputs)
	if (locale === "it") return it_resumes_duplicated(inputs)
	if (locale === "nl") return nl_resumes_duplicated(inputs)
	if (locale === "pl") return pl_resumes_duplicated(inputs)
	if (locale === "fi") return fi_resumes_duplicated(inputs)
	if (locale === "da") return da_resumes_duplicated(inputs)
	if (locale === "sv") return sv_resumes_duplicated(inputs)
	return en_resumes_duplicated(inputs)
});